export const CP_GET_STORE_LIST = 'CP_GET_STORE_LIST';

export const CP_GET_STORE_LIST_SUCCESS = 'CP_GET_STORE_LIST_SUCCESS';

export const CP_GET_STORE_LIST_FAILED = 'CP_GET_STORE_LIST_FAILED';